<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import PrintOptions from "@/components/modals/print-options.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    page: {
        title: "Purchase Order",
    },
    components: {
        Layout,
        PageHeader,
        DatePicker,
        PrintOptions,
        UploadPopover,
        RawData
    },
    data() {
        return {
            title: "Purchase Order",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Purchase Order",
                    active: true,
                },
            ],
            modalTitle: "",
            totalRows: 1,
            perPage: 10,
            perPagePosted: 5,
            currentPagePosted: 1,
            po: {
                id: 0,
                description: "",
                poDate: null,
                poNumber: "",
                deliveryInDays: 0,
            },
            poData: [],
            filterPO: "",
            pageOptions: [5, 10, 25, 50, 100],
            perPagePO: 5,
            currentPagePO: 1,
            poLoading: false,
            poIndex: -1,
            cycle: this.$store.state.data.cycle,
            tabIndex: 0,
            postedPO: [],
            filterPosted: "",
            uploadOptions: {
                type: "Purchase Order",
                placement: "right",
                folder: "Procurement",
            },
            unreceivedPO: [],
            filterUnreceived: "",
            currentPageUnreceived: 1,
            perPageUnreceived: 5,
            unreceivedLoading: false,
            poType: null,
            movePo: null,
            campusAccess: [],
            moveCampus: this.$store.state.data.selectedCampus.id,
            postedLoading: false,
        };
    },
    computed: {
        filteredPO() {
            let data = this.poData;
            var total = this.currentPagePO * this.perPagePO;
            if (this.filterPO.trim() != "" && this.filterPO) {
                data = data.filter((item) => {
                    return item.searchItem
                        .toUpperCase()
                        .includes(this.filterPO.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePO, total);
            if (this.currentPagePO > 1 && currentData.length == 0) {
                total = (this.currentPagePO - 1) * this.perPagePO;
                currentData = data.slice(total - this.perPagePO, total);
            }
            return currentData;
        },
        rowsPO() {
            if (this.filterPO.trim() != "" && this.filterPO) {
                return this.filteredPO.length;
            } else {
                return this.poData.length;
            }
        },
        filteredUnreceived() {
            let data = this.unreceivedPO;
            var total = this.currentPageUnreceived * this.perPageUnreceived;
            if (this.filterUnreceived.trim() != "" && this.filterUnreceived) {
                data = data.filter((item) => {
                    return item.searchItem
                        .toUpperCase()
                        .includes(this.filterUnreceived.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageUnreceived, total);
            if (this.currentPageUnreceived > 1 && currentData.length == 0) {
                total = (this.currentPageUnreceived - 1) * this.perPageUnreceived;
                currentData = data.slice(total - this.perPageUnreceived, total);
            }
            return currentData;
        },
        rowsUnreceived() {
            if (this.filterUnreceived.trim() != "" && this.filterUnreceived) {
                return this.filteredPosted.length;
            } else {
                return this.unreceivedPO.length;
            }
        },
        filteredPosted() {
            let data = this.postedPO;
            var total = this.currentPagePosted * this.perPagePosted;
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                data = data.filter((item) => {
                    return item.searchItem
                        .toUpperCase()
                        .includes(this.filterPosted.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPagePosted, total);
            if (this.currentPagePosted > 1 && currentData.length == 0) {
                total = (this.currentPagePosted - 1) * this.perPagePosted;
                currentData = data.slice(total - this.perPagePosted, total);
            }
            return currentData;
        },
        rowsPosted() {
            if (this.filterPosted.trim() != "" && this.filterPosted) {
                return this.filteredPosted.length;
            } else {
                return this.postedPO.length;
            }
        },
    },
    created() {
        var campuses = [{ text: `${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`, value: 0, disabled: true }];
        this.realCampus = [];
        this.$store.state.decrypt.campusAccessList().forEach((item) => {
        campuses.push({ value: item.Id, text: item.CampusName });
            this.realCampus.push({
                id: item.Id,
                campusName: item.CampusName,
                shortName: item.ShortName,
                isExternal: item.IsExternal,
            });
        });
        this.campusAccess = campuses;
        this.changeCycle(this.$store.state.data.cycle);
    },
    validations: {
        po: {
            description: { required },
            poDate: { required },
            poNumber: { required },
            deliveryInDays: { required }
        },
    },
    methods: {
        // Purchase Order
        async changeCycle(cycle) {
            await this.getPending(cycle, this.$store.state.data.selectedCampus.id);
            await this.getUnreceived(cycle, this.$store.state.data.selectedCampus.id);
            await this.getPosted(cycle, this.$store.state.data.selectedCampus.id);
        },
        async changeCampus(campusId){
            this.movePo = campusId;
            await this.getPending(this.$store.state.data.cycle, campusId);
            await this.getUnreceived(this.$store.state.data.cycle, campusId);
            await this.getPosted(this.$store.state.data.cycle, campusId);
        },
        async getPending(cycle, campusId) {
            this.poLoading = true;
            this.poData = [];
            await this.$store
                .dispatch("po/GetFPendingPo", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        this.poLoading = false;
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.poLoading = false;
                    res.data.forEach((item) => {
                        item.visible = true;
                        item.isSaving = false;
                        item.dateReceived = new Date(item.poDateReceived);
                        item.editDate = false;
                        item.dateError = false;
                        item.searchItem = `${item.poNumber} ${item.description} ${item.supplierName} ${item.prNumber}`;
                        item.addDocu = false;
                        item.poFiles = [];
                        item.attachmentLoading = false;
                        item.viewFile = false;
                        item.poFS = null;
                        item.viewFS = false;
                        item.poItems.map(y => {
                            y.editQuantity = false;
                            y.copyQuantity = cloneDeep(y.quantity);
                            y.copyNote = cloneDeep(y.prNote);
                        })
                    });
                    this.poData = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting pending P.O",
                        "error"
                    );
                    this.poLoading = false;
                });
        },
        async getUnreceived(cycle, campusId) {
            this.unreceivedLoading = true;
            this.unreceivedPO = [];
            await this.$store
                .dispatch("po/GetFUnreceivedPo", {cycle, campusId})
                .then((res) => {
                    this.unreceivedLoading = false;
                    res.data.forEach((item) => {
                        item.visible = false;
                        item.isSaving = false;
                        item.dateReceived = new Date(item.poDateReceived);
                        item.editDate = false;
                        item.dateError = false;
                        item.searchItem = `${item.poNumber} ${item.description} ${item.supplierName} ${item.prNumber}`;
                        item.addDocu = false;
                        item.poFiles = [];
                        item.attachmentLoading = false;
                        item.viewFile = false;
                        item.poFS = null;
                        item.viewFS = false;
                        item.poItems.map(y => {
                            y.editQuantity = false;
                            y.copyQuantity = cloneDeep(y.quantity);
                            y.copyNote = cloneDeep(y.prNote);
                        })
                    });
                    this.unreceivedPO = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting pending P.O",
                        "error"
                    );
                    this.unreceivedLoading = false;
                });
        },
        async getPosted(cycle, campusId) {
            this.postedLoading = true;
            this.postedPO = [];
            await this.$store
                .dispatch("po/GetFPostedPo", {cycle, campusId})
                .then((res) => {
                    this.postedLoading = false;
                    res.data.forEach((item) => {
                        item.visible = false;
                        item.isSaving = false;
                        item.dateReceived = new Date(item.poDateReceived);
                        item.editDate = false;
                        item.dateError = false;
                        item.searchItem = `${item.poNumber} ${item.description} ${item.supplierName} ${item.prNumber}`;
                        item.addDocu = false;
                        item.poFiles = [];
                        item.attachmentLoading = false;
                        item.viewFile = false;
                        item.poFS = null;
                        item.viewFS = false;
                        item.poItems.map(y => {
                            y.editQuantity = false;
                            y.copyQuantity = cloneDeep(y.quantity);
                            y.copyNote = cloneDeep(y.prNote);
                        })
                    });
                    this.postedPO = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong - getting posted P.O",
                        "error"
                    );
                    this.postedLoading = false;
                });
        },
        onResetPO() {
            this.po = {
                id: 0,
                description: "",
                campusId: this.$store.state.data.campus.id,
                cycle: "",
                poNumber: "",
                deliveryInDays: "",
            };
        },
        addNewPO() {
            this.onResetPO();
            this.po.cycle = cloneDeep(this.cycle);
            this.modalTitle = "Create New PO";
            this.$bvModal.show("po-modal");
        },
        hideModalPO() {
            this.$bvModal.hide("po-modal");
        },
        onCreatePO() {
            this.submitted = true;
            this.$v.po.$touch();
            if (this.$v.po.$invalid) {
                return;
            }
            var data = cloneDeep(this.po);
            data.poDate = this.getDate(this.po.poDate);
            data.cycle = this.$store.state.data.cycle;
            if (this.po.id > 0) {
                this.$store
                    .dispatch("po/UpdatePo", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        if(this.poType === 'unreceived'){
                            this.unreceivedPO[this.poIndex].description = res.data.description;
                            this.unreceivedPO[this.poIndex].poDate = data.poDate;
                            this.unreceivedPO[this.poIndex].poNumber = data.poNumber;
                            this.unreceivedPO[this.poIndex].deliveryInDays = data.deliveryInDays;
                        }else if(this.poType === 'conforme'){
                            this.postedPO[this.poIndex].description = res.data.description;
                            this.postedPO[this.poIndex].poDate = data.poDate;
                            this.postedPO[this.poIndex].poNumber = data.poNumber;
                            this.postedPO[this.poIndex].deliveryInDays = data.deliveryInDays;
                            this.postedPO[this.poIndex].expectedDelivery = this.addDays(data.poDateReceived, data.deliveryInDays)
                        }else{
                            this.poData[this.poIndex].description = res.data.description;
                            this.poData[this.poIndex].poDate = data.poDate;
                            this.poData[this.poIndex].poNumber = data.poNumber;
                            this.poData[this.poIndex].deliveryInDays = data.deliveryInDays;
                        }
                        this.$bvModal.hide("po-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong - updating PO",
                            "error"
                        );
                    });
            } else {
                this.$store
                    .dispatch("po/CreatePo", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(
                                res.data.errorMessage,
                                "error"
                            );
                        }
                        this.poData.push(res.data);
                        this.$bvModal.hide("po-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Something went wrong - creating PO",
                            "error"
                        );
                    });
            }
            this.submitted = false;
        },
        updatePO(row, type) {
            this.po = cloneDeep(row);
            this.po.poDate = new Date(row.poDate);
            if(type === 'unreceived'){
                this.poIndex = this.unreceivedPO.indexOf(row);
            }else if(type === 'conforme'){
                this.poIndex = this.postedPO.indexOf(row);
            }else{
                this.poIndex = this.poData.indexOf(row);
            }
            this.poType = type;
            this.modalTitle = "Update PO";
            this.$bvModal.show("po-modal");
        },
        deletePO(props) {
            var index = this.poData.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("po/DeletePo", props.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.poData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        postPO(id) {
            var index = this.poData.findIndex((item) => item.id == id);
            if(this.poData[index].deliveryInDays == 0){
                this.showToast("Please update delivery in days before posting!", "warning");
                return;
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("po/PostPo", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.postedPO.push(this.poData[index]);
                            this.unreceivedPO.push(this.poData[index]);
                            this.poData.splice(index, 1);
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                "Something went wrong - posting PO",
                                "error"
                            );
                        });
                }
            });
        },
        async printPO(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/PO",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printNTP(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/NTP",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async saveObligation(row){
            let requestStatus = !row.obligated;
            await this.$store
                .dispatch("po/PoObligation", { id: row.id, status: requestStatus })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.obligated = requestStatus;
                })
                .catch((err) => {
                    return this.showToast("Error obligating P.O", "error");
                });
        },
        async saveTrueObligation(id){
            await this.$store
                .dispatch("po/PoObligation", { id: id, status: true })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
                .catch((err) => {
                    return this.showToast("Error obligating P.O", "error");
                });
        },
        savePODate(row, type) {
            this.submitted = true;
            row.dateError = false;
            row.isSaving = true;
            if (row.dateReceived == null) {
                row.isSaving = false;
                return (row.dateError = true);
            }
            this.$store
                .dispatch("po/ReceivePo", {
                    id: row.id,
                    date: this.getDate(new Date(row.dateReceived)),
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.editDate = false;
                    row.isSaving = false;
                    if(type === 'unreceived'){
                        this.saveTrueObligation(row.id);
                        this.unreceivedPO.splice(this.unreceivedPO.indexOf(row), 1);
                        let index = this.postedPO.findIndex((item) => item.id == row.id);
                        if(index > -1){
                            this.postedPO[index].poDateReceived = res.data.poDateReceived;
                            this.postedPO[index].dateReceived = new Date(res.data.poDateReceived);
                            this.postedPO[index].expectedDelivery = this.addDays(res.data.poDateReceived, row.deliveryInDays);
                            this.postedPO[index].obligated = true;
                        }
                    }else{
                        row.expectedDelivery = this.addDays(res.data.poDateReceived, row.deliveryInDays);
                        console.log(res.data.poDateReceived);
                        console.log(row);
                    }
                    this.showToast("Successfully saving P.O Date!", "success");
                    this.submitted = false;
                })
                .catch((err) => {
                    this.submitted = false;
                    this.showToast("Error saving P.O Date", "error");
                });
        },
        cancelSaving(row) {
            row.editDate = false;
            row.dateError = false;
            row.dateReceived = new Date(row.poDateReceived);
        },
        postToPublic(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("publicpost/CreatePublicPostPO", { poId: id })
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.showToast(
                                "Successfully post to public",
                                "success"
                            );
                        })
                        .catch((err) => {
                            this.submitted = false;
                            this.showToast("Error posting to public", "error");
                        });
                }
            });
        },
        async getAttachments(row) {
            row.viewFile = true;
            row.poFiles = [];
            row.fileSearch = "";
            row.attachmentLoading = true;
            await this.getFiles(row);
        },
        async getFiles(row){
            await this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                })
                .then((res) => {
                    row.attachmentLoading = false;
                    row.poFiles = res.data;
                })
                .catch(() => {
                    row.attachmentLoading = false;
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        searchDocu(row) {
            let data = row.poFiles;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        removeFile(id, parentId, type) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            if (type == "pending") {
                                let index = this.poData.findIndex(
                                    (item) => item.id == parentId
                                );
                                let yIndex = this.poData[
                                    index
                                ].poFiles.findIndex((item) => item.id == id);
                                this.poData[index].poFiles.splice(yIndex, 1);
                            } else {
                                let index = this.postedPO.findIndex(
                                    (item) => item.id == parentId
                                );
                                let yIndex = this.postedPO[
                                    index
                                ].poFiles.findIndex((item) => item.id == id);
                                this.postedPO[index].poFiles.splice(yIndex, 1);
                            }
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        uploadedFiles() {},
        async editUnservePOReceivedDate(row) {
            if(row.poFiles.length == 0){
                this.pageLoader(true);
                await this.getFiles(row);
                this.pageLoader(false);
            }
            if(row.poFiles.length > 0){
                row.editDate = true;
            }else{
                this.showToast("Please upload document to this P.O first!", "warning");
            }
        },
        async getPOFundSource(row){
            await this.$store
                .dispatch("po/GetPOFundSource", row.id)
                .then((res) => {
                    if(res.error){
                        return this.showToast(res.errorMessage, "error");
                    }
                    row.poFS = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        async viewFS(row) {
            row.viewFS = true;
            if(row.poFS) return;
            await this.getPOFundSource(row)
        },
        updateQuantity(row) {
            row.copyQuantity = cloneDeep(row.quantity);
            row.editQuantity = true;
        },
        cancelUpdateQty(row){
            row.editQuantity = false;
            row.quantity = cloneDeep(row.copyQuantity);
        },
        async saveDetails(row){
            let offerRequest = cloneDeep(row);
            offerRequest.quantity = this.getExactAmt(row.quantity);
            offerRequest.id = row.rfqSupplierOfferId;
            if(offerRequest.quantity != row.copyQuantity){
                await this.saveQuantity(offerRequest);
            }
            if(offerRequest.prNote != row.copyNote){
                await this.saveNoteOffer(offerRequest);
            }
            this.showToast("Successfully updated", "success");
            row.editQuantity = false;
        },
        async saveQuantity(offerRequest){
            await this.$store
                .dispatch("rfqsupplieroffer/UpdateQuantity", offerRequest)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async saveNoteOffer(offerRequest){
            await this.$store
                .dispatch("pritem/UpdatePrItemNote", {
                    id: offerRequest.prItemId,
                    note: offerRequest.prNote
                })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        moveToAnotherCampus(row){
            this.modalTitle = `Select ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`;
            this.movePo = cloneDeep(row);
            this.$bvModal.show('move-to-campus-modal');
        },
        onMoveToAnotherCampus(){
            this.submitted = true;
            if(this.moveCampus == 0 || !this.moveCampus){
                this.showToast("Please select campus!", "warning");
                return;
            }
            this.$store
                .dispatch("po/MoveToCampus", {id: this.movePo.id, campusId: this.moveCampus})
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.postedPO.splice(this.postedPO.findIndex(x => x.id == this.movePo), 1);
                    this.showToast("Successfully moved!", "success");
                    this.$bvModal.hide('move-to-campus-modal');
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        printDP(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Deployment",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        generatePOStatus(){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/Po/Status",
                routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        }
    },
};
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="po-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreatePO"
                class="needs-validation"
                ref="apiForm"
            >
                <b-row>
                    <b-col>
                        <div class="mb-3">
                            <label for="description">Description </label>
                            <textarea
                                id="description"
                                rows="3"
                                v-model="po.description"
                                placeholder="Enter Description..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted && $v.po.description.$error,
                                }"
                            ></textarea>
                            <div
                                v-if="submitted && $v.po.description.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.po.description.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="description">P.O Date </label>
                            <date-picker
                                v-model="
                                    po.poDate
                                "
                                lang="en"
                                placeholder="Enter P.O Date..."
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                         $v.po.poDate.$error,
                                }"
                            ></date-picker>
                            <div
                                v-if="submitted && $v.po.poDate.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.po.poDate.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="description">P.O Number </label>
                            <input
                                v-model="
                                    po.poNumber
                                "
                                autocomplete="off"
                                placeholder="Enter P.O Number..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                         $v.po.poNumber.$error,
                                }"
                            >
                            <div
                                v-if="submitted && $v.po.poNumber.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.po.poNumber.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="description">Delivery in Days </label>
                            <input
                                v-model="po.deliveryInDays"
                                autocomplete="off"
                                placeholder="Enter Delivery in Days..."
                                class="form-control"
                                :class="{
                                    'is-invalid':
                                        submitted &&
                                         $v.po.deliveryInDays.$error,
                                }"
                            >
                            <div
                                v-if="submitted && $v.po.deliveryInDays.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.po.deliveryInDays.required"
                                    >This value is required.</span
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('po-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="move-to-campus-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onMoveToAnotherCampus"
                class="needs-validation"
                ref="apiForm"
            >
                <div class="mb-3">
                    <label for="name">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
                    <b-form-select
                        v-model="moveCampus"
                        :options="campusAccess"
                        class="form-select">
                    </b-form-select>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Move
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('move-to-campus-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-row class="mb-1">
            <b-col sm="6" class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <h4 class="mb-0"></h4>
                </div>
            </b-col>
            <div class="col-md-6 text-right"></div>
        </b-row>
        <div class="position-relative">
            <b-tabs
                content-class="pt-3 pb-3 text-muted"
                v-model="tabIndex"
                nav-class="nav-tabs-custom"
            >
                <b-tab>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Pending P.O</span>
                    </template>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex align-items-center h-100">
                                <h4 class="mb-0">Pending P.O List</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex float-end">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterPO"
                                            type="search"
                                            placeholder="Search P.O..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                            mb-0
                                        "
                                    >
                                        <b-form-select
                                            class="form-select"
                                            v-model="perPagePO"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="poData.length == 0 && !poLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>No Data
                            Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="poData.length > 0 && filteredPO.length == 0 && !poLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>Search
                            Not Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="poLoading"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-25px h-25px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mb-0">Loading...</h5>
                    </div>
                    <div role="tablist" v-for="x in filteredPO" :key="x.id">
                        <b-card no-body class="mb-1 shadow-none position-relative">
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                            <b-card-header header-tag="header" role="tab">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <div>
                                        <span>{{ x.poNumber }}</span>
                                        <h4 class="mb-0">{{ x.description }}</h4>
                                        <small
                                            >{{
                                                x.supplierName
                                            }}&nbsp;[<a
                                                href="javascript:void(0);"
                                                @click="x.visible = !x.visible"
                                                >{{
                                                    x.visible ? "Hide" : "Show More"
                                                }}
                                                Details</a
                                            >]</small
                                        >
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-purple
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="printPO(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-printer
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Print P.O</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-success
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="postPO(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-check
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Post P.O</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-dark
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="updatePO(x)"
                                            ><i
                                                class="
                                                    mdi mdi-square-edit-outline
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Edit P.O</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-danger
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="deletePO(x)"
                                            ><i
                                                class="
                                                    mdi mdi-trash-can
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Delete P.O</span>
                                        </a>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.visible"
                                :accordion="`pending-accordion-${x.id}`"
                                role="tabpanel"
                            >
                                <b-card-body>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <b class="font-size-16"
                                                >Supplier Details:</b
                                            >
                                            <div class="d-flex ms-4 mt-2">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Name:
                                                    {{
                                                        x.supplierName
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Address:
                                                    {{
                                                        x.supplierAddress
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Contact No.:
                                                    {{
                                                        x.supplierContactNumber
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Email:
                                                    <a href="javascript:void(0);">{{
                                                        x.supplierEmailAddress
                                                    }}</a></span
                                                >
                                            </div>
                                            <div
                                                class="d-flex ms-4"
                                                v-if="x.rfqSupplierNote"
                                            >
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Note:
                                                    {{
                                                        x.rfqSupplierNote
                                                    }}</span
                                                >
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <b class="font-size-16 me-2">PR No:</b>
                                                    <span class="text-warning font-size-15">{{ x.prNumber }}</span>
                                                </div>
                                            </div>
                                            <div
                                                class="
                                                    mt-2
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <b class="font-size-16"
                                                    ><i class="bx bx-paperclip"></i
                                                    >Attachments</b
                                                >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="ms-1"
                                                    @click="getAttachments(x)"
                                                    :id="`viewFiles-${x.id}`"
                                                    >[Show attachments]</a
                                                >
                                                <b-popover
                                                    :target="`viewFiles-${x.id}`"
                                                    triggers="click"
                                                    placement="right"
                                                    :show.sync="x.viewFile"
                                                    custom-class="popover-supplier"
                                                >
                                                    <template v-slot:title>
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                            "
                                                        >
                                                            <small
                                                                >Attachments</small
                                                            >
                                                            <span
                                                                class="
                                                                    bx bx-x
                                                                    font-size-14
                                                                    cursor-pointer
                                                                "
                                                                @click="
                                                                    x.viewFile = false
                                                                "
                                                            ></span>
                                                        </div>
                                                    </template>
                                                    <table
                                                        class="table table-bordered"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length > 0
                                                        "
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    File Description
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 30px;
                                                                    "
                                                                ></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poFiles"
                                                                :key="y.id"
                                                            >
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="hoverable-link"
                                                                        @click="openDocument(y)"
                                                                    >
                                                                        {{ y.description }}
                                                                    </a>
                                                                    <small class="d-block">Uploaded by {{y.uploadedBy}}</small>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="
                                                                            hoverable-link
                                                                        "
                                                                        @click="
                                                                            removeFile(
                                                                                y.id,
                                                                                x.id,
                                                                                'pending'
                                                                            )
                                                                        "
                                                                        ><i
                                                                            class="
                                                                                bx
                                                                                bx-trash
                                                                                text-danger
                                                                            "
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div
                                                        class="text-center"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length == 0
                                                        "
                                                    >
                                                        No data found
                                                    </div>
                                                    <div
                                                        v-if="x.attachmentLoading"
                                                        class="text-center"
                                                    >
                                                        <b-spinner
                                                            variant="primary"
                                                            label="Loading..."
                                                        ></b-spinner>
                                                    </div>
                                                </b-popover>
                                            </div>
                                            <div class="mt-3">
                                                <button
                                                    type="button"
                                                    class="btn btn-success me-1"
                                                    @click="postPO(x.id)"
                                                >
                                                    <i class="bx bx-check me-1"></i
                                                    >Post P.O
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-1"
                                                    @click="printPO(x.id)"
                                                >
                                                    <i
                                                        class="bx bx-printer me-1"
                                                    ></i
                                                    >Print P.O
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-success"
                                                    @click="x.addDocu = true"
                                                    :id="`po-document${x.id}`"
                                                >
                                                    <i class="bx bx-plus"></i>Add
                                                    Attachments
                                                </button>
                                                <upload-popover
                                                    :option="uploadOptions"
                                                    :sourceId="x.id"
                                                    @uploaded="uploadedFiles"
                                                    :showPV="x.addDocu"
                                                    @closePopover="
                                                        x.addDocu = false
                                                    "
                                                    :dzId="`dropzone-po${x.id}`"
                                                    :pvId="`po-document${x.id}`"
                                                ></upload-popover>
                                            </div>
                                        </div>
                                        <div class="col-md-7 border-start border-3">
                                            <div class="ms-2">
                                                <div class="mb-2">
                                                    <b class="font-size-16"
                                                        >Supplier Offers:</b
                                                    >
                                                </div>
                                                <div>
                                                    <table width="100%">
                                                        <thead>
                                                            <tr
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <th
                                                                    style="
                                                                        width: 90px;
                                                                    "
                                                                    class="py-2"
                                                                >
                                                                    Qty
                                                                </th>
                                                                <th class="py-2">
                                                                    Item Name
                                                                </th>
                                                                <th class="py-2" style="width: 150px;">
                                                                    Notes
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Unit Price
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Total Price
                                                                </th>
                                                                <th style="width:50px;"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poItems"
                                                                :key="y.id"
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <td class="py-2 px-2">
                                                                    <span v-if="!y.editQuantity">{{ y.quantity }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.quantity"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    <div>
                                                                        {{
                                                                            y.itemName
                                                                        }}
                                                                    </div>
                                                                    <small>{{
                                                                        y.description
                                                                    }}</small>
                                                                </td>
                                                                <td class="py-2">
                                                                    <span v-if="!y.editQuantity">{{ y.prNote }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.prNote"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost *
                                                                                y.quantity
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <a href="javascript:void(0);" v-if="!y.editQuantity" class="text-white font-size-18" @click="updateQuantity(y)" title="Edit Quantity"><i class="bx bx-edit"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-success me-1 font-size-18" @click="saveDetails(y)" title="Save Quantity"><i class="bx bx-check"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-white font-size-18" @click="cancelUpdateQty(y)" title="Cancel"><i class="bx bx-x"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="text-right mt-4">
                                                        <button type="button" class="btn btn-purple" @click="printDP(x.id)"><i class="bx bx-printer me-1"></i>Print Deployment</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <div class="row mb-2 mt-4" v-if="poData.length > 0">
                        <div class="col-md-12 text-right">
                            <ul
                                class="pagination pagination-rounded mb-0 float-end"
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPagePO"
                                    :total-rows="rowsPO"
                                    :per-page="perPagePO"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </b-tab>
                
                <b-tab>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Unserve P.O</span>
                    </template>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex align-items-center h-100">
                                <h4 class="mb-0">Unserve P.O List</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex float-end">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterUnreceived"
                                            type="search"
                                            placeholder="Search P.O..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                            mb-0
                                        "
                                    >
                                        <b-form-select
                                            class="form-select"
                                            v-model="perPageUnreceived"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="unreceivedPO.length == 0 && !unreceivedLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>No Data
                            Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="unreceivedPO.length > 0 && filteredUnreceived.length == 0 && !unreceivedLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>Search
                            Not Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="unreceivedLoading"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-25px h-25px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mb-0">Loading...</h5>
                    </div>
                    <div
                        role="tablist"
                        v-for="x in filteredUnreceived"
                        :key="x.id"
                        class="mb-2"
                    >
                        <b-card no-body class="mb-1 shadow-none position-relative">
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                            <b-card-header header-tag="header" role="tab">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <div>
                                        <span>{{ x.poNumber }}</span>
                                        <h4 class="mb-0">{{ x.description }}</h4>
                                        <small
                                            >{{
                                                x.supplierName
                                            }}&nbsp;[<a
                                                href="javascript:void(0);"
                                                @click="x.visible = !x.visible"
                                                >{{
                                                    x.visible ? "Hide" : "Show More"
                                                }}
                                                Details</a
                                            >]</small
                                        >
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-purple
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="printPO(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-printer
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2"
                                                >Print Final P.O</span
                                            >
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-purple
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                                me-1
                                            "
                                            @click="printNTP(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-printer
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Print NTP</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-dark
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="updatePO(x, 'unreceived')"
                                            ><i
                                                class="
                                                    mdi mdi-square-edit-outline
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Edit P.O</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                                text-danger
                                            "
                                            @click="deletePO(x, 'unreceived')"
                                            v-if="$store.state.decrypt.isAdmin()"
                                            ><i
                                                class="
                                                    mdi mdi-trash-can-outline
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Delete P.O</span>
                                        </a>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.visible"
                                :accordion="`received-accordion-${x.id}`"
                                role="tabpanel"
                            >
                                <b-card-body>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <b class="font-size-16"
                                                >Supplier Details:</b
                                            >
                                            <div class="d-flex ms-4 mt-2">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Name:
                                                    {{
                                                        x.supplierName
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Address:
                                                    {{
                                                        x.supplierAddress
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Contact No.:
                                                    {{
                                                        x.supplierContactNumber
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Email:
                                                    <a href="javascript:void(0);">{{
                                                        x.supplierEmailAddress
                                                    }}</a></span
                                                >
                                            </div>
                                            <div
                                                class="d-flex ms-4"
                                                v-if="x.supplierNote"
                                            >
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Note:
                                                    {{
                                                        x.supplierNote
                                                    }}</span
                                                >
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <b class="font-size-16 me-2">PR No:</b>
                                                    <span class="text-warning font-size-15">{{ x.prNumber }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div
                                                    class="
                                                        d-flex
                                                        align-items-center
                                                    "
                                                >
                                                    <span
                                                        class="
                                                            font-size-16
                                                            me-1
                                                            no-wrap
                                                        "
                                                        ><b
                                                            ><i
                                                                class="
                                                                    bx bx-calendar
                                                                    font-size-16
                                                                "
                                                            ></i>
                                                            Supplier Date Received:</b
                                                        ></span
                                                    >
                                                    <div class="d-flex align-items-center" v-if="!x.editDate">
                                                        <span class="font-size-16 ms-1">
                                                            <!-- {{ formatDate(x.dateReceived) }} -->
                                                        </span>
                                                        <a 
                                                            href="javascript:void(0);" 
                                                            class=" d-flex align-items-center"
                                                            @click="editUnservePOReceivedDate(x)"
                                                        >
                                                            <!-- hover-max-width -->
                                                            <i class="bx bx-edit font-size-16 mx-1"></i>
                                                            <span>Edit P.O Received Date</span>
                                                        </a>
                                                    </div>
                                                    <div
                                                        class="d-flex w-100"
                                                        v-if="x.editDate"
                                                    >
                                                        <div class="w-100">
                                                            <date-picker
                                                                v-model="
                                                                    x.dateReceived
                                                                "
                                                                lang="en"
                                                                placeholder="Enter Supplier Date Received..."
                                                                :class="{
                                                                    'is-invalid':
                                                                        submitted &&
                                                                        x.dateError,
                                                                }"
                                                            ></date-picker>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            class="
                                                                ms-2
                                                                btn btn-success
                                                                no-wrap
                                                            "
                                                            @click="savePODate(x, 'unreceived')"
                                                        >
                                                            <span
                                                                class="
                                                                    spinner-border
                                                                    text-dark
                                                                "
                                                                style="
                                                                    width: 15px;
                                                                    height: 15px;
                                                                "
                                                                v-if="x.isSaving"
                                                            ></span>
                                                            <span v-else
                                                                ><i
                                                                    class="
                                                                        bx bx-save
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Save</span
                                                            >
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="
                                                                ms-2
                                                                btn
                                                                no-wrap
                                                                btn-link
                                                            "
                                                            @click="cancelSaving(x)"
                                                        >
                                                            <span>Cancel</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <div class="form-checkbox-outline form-check-success mb-0">
                                                        <input
                                                            autocomplete="off"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="`is-obligated-${x.id}`"
                                                            v-model="x.obligated"
                                                            @click="saveObligation(x)"
                                                        />&nbsp;&nbsp;
                                                        <label :for="`is-obligated-${x.id}`">
                                                            <b class="font-size-16">Is Obligated?</b>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <b class="font-size-16"
                                                    ><i class="bx bx-paperclip"></i
                                                    >Attachments</b
                                                >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="ms-1"
                                                    @click="getAttachments(x)"
                                                    :id="`viewFiles-unserved-${x.id}`"
                                                    >[Show attachments]</a
                                                >
                                                <b-popover
                                                    :target="`viewFiles-unserved-${x.id}`"
                                                    triggers="click"
                                                    placement="right"
                                                    :show.sync="x.viewFile"
                                                    custom-class="popover-supplier"
                                                >
                                                    <template v-slot:title>
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                            "
                                                        >
                                                            <small
                                                                >Attachments</small
                                                            >
                                                            <span
                                                                class="
                                                                    bx bx-x
                                                                    font-size-14
                                                                    cursor-pointer
                                                                "
                                                                @click="
                                                                    x.viewFile = false
                                                                "
                                                            ></span>
                                                        </div>
                                                    </template>
                                                    <table
                                                        class="table table-bordered"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length > 0
                                                        "
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    File Description
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 30px;
                                                                    "
                                                                ></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poFiles"
                                                                :key="y.id"
                                                            >
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="
                                                                            hoverable-link
                                                                        "
                                                                        @click="
                                                                            openDocument(
                                                                                y
                                                                            )
                                                                        "
                                                                        >{{
                                                                            y.description
                                                                        }}</a
                                                                    >
                                                                    <small class="d-block">Uploaded by {{y.uploadedBy}}</small>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="
                                                                            hoverable-link
                                                                        "
                                                                        @click="
                                                                            removeFile(
                                                                                y.id,
                                                                                x.id,
                                                                                'posted'
                                                                            )
                                                                        "
                                                                        ><i
                                                                            class="
                                                                                bx
                                                                                bx-trash
                                                                                text-danger
                                                                            "
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div
                                                        class="text-center"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length == 0
                                                        "
                                                    >
                                                        No data found
                                                    </div>
                                                    <div
                                                        v-if="x.attachmentLoading"
                                                        class="text-center"
                                                    >
                                                        <b-spinner
                                                            variant="primary"
                                                            label="Loading..."
                                                        ></b-spinner>
                                                    </div>
                                                </b-popover>
                                            </div>
                                            <div class="mt-2">
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-2"
                                                    @click="printPO(x.id)"
                                                >
                                                    <i
                                                        class="bx bx-printer me-1"
                                                    ></i
                                                    >Print Final P.O
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-2"
                                                    @click="printNTP(x.id)"
                                                >
                                                    <i
                                                        class="bx bx-printer me-1"
                                                    ></i
                                                    >Print NTP
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-success"
                                                    @click="x.addDocu = true"
                                                    :id="`po-document-unserved${x.id}`"
                                                >
                                                    <i class="bx bx-plus"></i>Add
                                                    Attachments
                                                </button>
                                                <upload-popover
                                                    :option="uploadOptions"
                                                    :sourceId="x.id"
                                                    @uploaded="uploadedFiles"
                                                    :showPV="x.addDocu"
                                                    @closePopover="x.addDocu = false"
                                                    :dzId="`dropzone-po${x.id}`"
                                                    :pvId="`po-document-unserved${x.id}`"
                                                ></upload-popover>
                                                <!-- <button
                                                    type="button"
                                                    class="btn btn-success"
                                                    @click="postToPublic(x.id)"
                                                >
                                                    <i class="bx bx-check me-1"></i
                                                    >Post to Public
                                                </button> -->
                                            </div>
                                        </div>
                                        <div class="col-md-7 border-start border-3">
                                            <div class="ms-2">
                                                <div class="mb-2">
                                                    <b class="font-size-16"
                                                        >Supplier Offers:</b
                                                    >
                                                </div>
                                                <div>
                                                    <table width="100%">
                                                        <thead>
                                                            <tr
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <th
                                                                    style="
                                                                        width: 90px;
                                                                    "
                                                                    class="py-2"
                                                                >
                                                                    Qty
                                                                </th>
                                                                <th class="py-2">
                                                                    Item Name
                                                                </th>
                                                                <th class="py-2" style="width: 150px;">
                                                                    Notes
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Unit Price
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Total Price
                                                                </th>
                                                                <th style="width:50px;"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poItems"
                                                                :key="y.id"
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <td class="py-2 px-2">
                                                                    <span v-if="!y.editQuantity">{{ y.quantity }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.quantity"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    <div>
                                                                        {{
                                                                            y.itemName
                                                                        }}
                                                                    </div>
                                                                    <small>{{
                                                                        y.description
                                                                    }}</small>
                                                                </td>
                                                                <td class="py-2">
                                                                    <span v-if="!y.editQuantity">{{ y.prNote }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.prNote"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost *
                                                                                y.quantity
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <a href="javascript:void(0);" v-if="!y.editQuantity" class="text-white font-size-18" @click="updateQuantity(y)" title="Edit Quantity"><i class="bx bx-edit"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-success font-size-18 me-1" @click="saveDetails(y)" title="Save Quantity"><i class="bx bx-check"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-white font-size-18" @click="cancelUpdateQty(y)" title="Cancel"><i class="bx bx-x"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="text-right mt-4">
                                                        <button type="button" class="btn btn-purple" @click="printDP(x.id)"><i class="bx bx-printer me-1"></i>Print Deployment</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <div class="row mb-2 mt-4" v-if="unreceivedPO.length > 0">
                        <div class="col-md-12 text-right">
                            <ul
                                class="pagination pagination-rounded mb-0 float-end"
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPageUnreceived"
                                    :total-rows="rowsUnreceived"
                                    :per-page="perPageUnreceived"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </b-tab>
                
                <b-tab>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="bx bx-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Served P.O</span>
                    </template>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex align-items-center h-100">
                                <h4 class="mb-0">Served P.O List</h4>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex float-end">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter me-1"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterPosted"
                                            type="search"
                                            placeholder="Search P.O..."
                                            class="form-control"
                                        ></b-form-input>
                                    </label>
                                </div>
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="
                                            d-inline-flex
                                            align-items-center
                                            mb-0
                                        "
                                    >
                                        <b-form-select
                                            class="form-select"
                                            v-model="perPagePosted"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="postedPO.length == 0 && !postedLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>No Data
                            Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="postedPO.length > 0 && filteredPosted.length == 0 && !postedLoading"
                    >
                        <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>Search
                            Not Found
                        </h5>
                    </div>
                    <div
                        class="
                            h-50vh
                            d-flex
                            align-items-center
                            justify-content-center
                        "
                        v-if="postedLoading"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-25px h-25px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <h5 class="mb-0">Loading...</h5>
                    </div>
                    <div
                        role="tablist"
                        v-for="x in filteredPosted"
                        :key="x.id"
                        class="mb-2"
                    >
                        <b-card no-body class="mb-1 shadow-none position-relative">
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                            <b-card-header header-tag="header" role="tab">
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <div>
                                        <span>{{ x.poNumber }}</span>
                                        <h4 class="mb-0">{{ x.description }}</h4>
                                        <small
                                            >{{
                                                x.supplierName
                                            }}&nbsp;[<a
                                                href="javascript:void(0);"
                                                @click="x.visible = !x.visible"
                                                >{{
                                                    x.visible ? "Hide" : "Show More"
                                                }}
                                                Details</a
                                            >]</small
                                        >
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-purple
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="printPO(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-printer
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2"
                                                >Print Final P.O</span
                                            >
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-purple
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                                me-1
                                            "
                                            @click="printNTP(x.id)"
                                            v-if="!x.visible"
                                            ><i
                                                class="
                                                    mdi mdi-printer
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Print NTP</span>
                                        </a>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                action-icon
                                                text-dark
                                                hover-max-width
                                                d-flex
                                                align-items-center
                                            "
                                            @click="updatePO(x, 'conforme')"
                                            ><i
                                                class="
                                                    mdi mdi-square-edit-outline
                                                    font-size-22
                                                    me-1
                                                "
                                            ></i>
                                            <span class="me-2">Edit P.O</span>
                                        </a>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.visible"
                                :accordion="`posted-accordion-${x.id}`"
                                role="tabpanel"
                            >
                                <b-card-body>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <b class="font-size-16"
                                                >Supplier Details:</b
                                            >
                                            <div class="d-flex ms-4 mt-2">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Name:
                                                    {{
                                                        x.supplierName
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Address:
                                                    {{
                                                        x.supplierAddress
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Contact No.:
                                                    {{
                                                        x.supplierContactNumber
                                                    }}</span
                                                >
                                            </div>
                                            <div class="d-flex ms-4">
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Email:
                                                    <a href="javascript:void(0);">{{
                                                        x.supplierEmailAddress
                                                    }}</a></span
                                                >
                                            </div>
                                            <div
                                                class="d-flex ms-4"
                                                v-if="x.supplierNote"
                                            >
                                                <i class="me-2">-</i
                                                ><span class="font-size-14"
                                                    >Note:
                                                    {{
                                                        x.supplierNote
                                                    }}</span
                                                >
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <b class="font-size-16 me-2">PR No:</b>
                                                    <span class="text-warning font-size-15">{{ x.prNumber }}</span>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <span class="font-size-16 me-1 no-wrap">
                                                        <b>
                                                            <i class="bx bx-calendar font-size-16"></i>
                                                            Supplier Date Received:
                                                        </b>
                                                    </span>
                                                    <div class="d-flex align-items-center" v-if="!x.editDate">
                                                        <span class="font-size-16 ms-1">
                                                            {{ formatDate(x.dateReceived) }}
                                                        </span>
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="hover-max-width d-flex align-items-center"
                                                            @click="x.editDate = true"
                                                        >
                                                            <i class="bx bx-edit font-size-16 mx-1"></i>
                                                            <span>Edit P.O Received Date</span>
                                                        </a>
                                                    </div>
                                                    <div
                                                        class="d-flex w-100"
                                                        v-if="x.editDate"
                                                    >
                                                        <div class="w-100">
                                                            <date-picker
                                                                v-model="
                                                                    x.dateReceived
                                                                "
                                                                lang="en"
                                                                placeholder="Enter Supplier Date Received..."
                                                                :class="{
                                                                    'is-invalid':
                                                                        submitted &&
                                                                        x.dateError,
                                                                }"
                                                            ></date-picker>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            class="
                                                                ms-2
                                                                btn btn-success
                                                                no-wrap
                                                            "
                                                            @click="savePODate(x, 'posted')"
                                                        >
                                                            <span
                                                                class="
                                                                    spinner-border
                                                                    text-dark
                                                                "
                                                                style="
                                                                    width: 15px;
                                                                    height: 15px;
                                                                "
                                                                v-if="x.isSaving"
                                                            ></span>
                                                            <span v-else
                                                                ><i
                                                                    class="
                                                                        bx bx-save
                                                                        me-1
                                                                    "
                                                                ></i
                                                                >Save</span
                                                            >
                                                        </button>
                                                        <button
                                                            type="button"
                                                            class="
                                                                ms-2
                                                                btn
                                                                no-wrap
                                                                btn-link
                                                            "
                                                            @click="cancelSaving(x)"
                                                        >
                                                            <span>Cancel</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <b class="font-size-16 me-2">Expected Delivery:</b>
                                                    <span class="text-warning font-size-15">{{ formatDate(new Date(x.expectedDelivery))}}</span>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <b class="font-size-16 me-2">Fund Source:</b>
                                                    <span class="text-warning font-size-15">
                                                        <a href="javascript:void(0);" :id="`fundSource-po${x.id}`" @click="viewFS(x)">Show Fund Source</a>
                                                        <b-popover
                                                            :target="`fundSource-po${x.id}`"
                                                            triggers="click"
                                                            placement="right"
                                                            :show.sync="x.viewFS"
                                                        >
                                                            <template v-slot:title>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                        justify-content-between
                                                                    "
                                                                >
                                                                    <small
                                                                        >P.O Fund Source</small
                                                                    >
                                                                    <span
                                                                        class="
                                                                            bx bx-x
                                                                            font-size-14
                                                                            cursor-pointer
                                                                        "
                                                                        @click="
                                                                            x.viewFS = false
                                                                        "
                                                                    ></span>
                                                                </div>
                                                            </template>
                                                            {{x.poFS ? x.poFS.sourceName : 'Loading...'}}
                                                        </b-popover>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="d-flex align-items-center">
                                                    <div class="form-check form-checkbox-outline form-check-success mb-0">
                                                        <input
                                                            autocomplete="off"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="`is-obligated-${x.id}`"
                                                            v-model="x.obligated"
                                                            @click="saveObligation(x)"
                                                        />&nbsp;&nbsp;
                                                        <label  class="form-check-label" :for="`is-obligated-${x.id}`">
                                                            <b class="font-size-16">Is Obligated?</b>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <b class="font-size-16"
                                                    ><i class="bx bx-paperclip"></i
                                                    >Attachments</b
                                                >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="ms-1"
                                                    @click="getAttachments(x)"
                                                    :id="`viewFiles-${x.id}`"
                                                    >[Show attachments]</a
                                                >
                                                <b-popover
                                                    :target="`viewFiles-${x.id}`"
                                                    triggers="click"
                                                    placement="right"
                                                    :show.sync="x.viewFile"
                                                    custom-class="popover-supplier"
                                                >
                                                    <template v-slot:title>
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-items-center
                                                                justify-content-between
                                                            "
                                                        >
                                                            <small
                                                                >Attachments</small
                                                            >
                                                            <span
                                                                class="
                                                                    bx bx-x
                                                                    font-size-14
                                                                    cursor-pointer
                                                                "
                                                                @click="
                                                                    x.viewFile = false
                                                                "
                                                            ></span>
                                                        </div>
                                                    </template>
                                                    <table
                                                        class="table table-bordered"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length > 0
                                                        "
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    File Description
                                                                </th>
                                                                <th
                                                                    style="
                                                                        width: 30px;
                                                                    "
                                                                ></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poFiles"
                                                                :key="y.id"
                                                            >
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="
                                                                            hoverable-link
                                                                        "
                                                                        @click="
                                                                            openDocument(
                                                                                y
                                                                            )
                                                                        "
                                                                        >{{
                                                                            y.description
                                                                        }}</a
                                                                    >
                                                                    <small class="d-block">Uploaded by {{y.uploadedBy}}</small>
                                                                </td>
                                                                <td>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="
                                                                            hoverable-link
                                                                        "
                                                                        @click="
                                                                            removeFile(
                                                                                y.id,
                                                                                x.id,
                                                                                'posted'
                                                                            )
                                                                        "
                                                                        ><i
                                                                            class="
                                                                                bx
                                                                                bx-trash
                                                                                text-danger
                                                                            "
                                                                        ></i
                                                                    ></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div
                                                        class="text-center"
                                                        v-if="
                                                            !x.attachmentLoading &&
                                                            x.poFiles.length == 0
                                                        "
                                                    >
                                                        No data found
                                                    </div>
                                                    <div
                                                        v-if="x.attachmentLoading"
                                                        class="text-center"
                                                    >
                                                        <b-spinner
                                                            variant="primary"
                                                            label="Loading..."
                                                        ></b-spinner>
                                                    </div>
                                                </b-popover>
                                            </div>
                                            <div class="mt-2">
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-2"
                                                    @click="printPO(x.id)"
                                                >
                                                    <i
                                                        class="bx bx-printer me-1"
                                                    ></i
                                                    >Print Final P.O
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-purple me-2"
                                                    @click="printNTP(x.id)"
                                                >
                                                    <i
                                                        class="bx bx-printer me-1"
                                                    ></i
                                                    >Print NTP
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-success me-2"
                                                    @click="x.addDocu = true"
                                                    :id="`po-document${x.id}`"
                                                >
                                                    <i class="bx bx-plus"></i>Add
                                                    Attachments
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-warning"
                                                    @click="moveToAnotherCampus(x)"
                                                >
                                                    <i class="bx bx-upload"></i>Move to another {{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }}
                                                </button>
                                                <upload-popover
                                                    :option="uploadOptions"
                                                    :sourceId="x.id"
                                                    @uploaded="uploadedFiles"
                                                    :showPV="x.addDocu"
                                                    @closePopover="x.addDocu = false"
                                                    :dzId="`dropzone-po${x.id}`"
                                                    :pvId="`po-document${x.id}`"
                                                ></upload-popover>
                                                <!-- <button
                                                    type="button"
                                                    class="btn btn-success"
                                                    @click="postToPublic(x.id)"
                                                >
                                                    <i class="bx bx-check me-1"></i
                                                    >Post to Public
                                                </button> -->
                                            </div>
                                        </div>
                                        <div class="col-md-7 border-start border-3">
                                            <div class="ms-2">
                                                <div class="mb-2">
                                                    <b class="font-size-16"
                                                        >Supplier Offers:</b
                                                    >
                                                </div>
                                                <div>
                                                    <table width="100%">
                                                        <thead>
                                                            <tr
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <th
                                                                    style="
                                                                        width: 90px;
                                                                    "
                                                                    class="py-2"
                                                                >
                                                                    Qty
                                                                </th>
                                                                <th class="py-2">
                                                                    Item Name
                                                                </th>
                                                                <th class="py-2" style="width: 150px;">
                                                                    Notes
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Unit Price
                                                                </th>
                                                                <th
                                                                    class="py-2"
                                                                    style="width: 150px;"
                                                                >
                                                                    Total Price
                                                                </th>
                                                                <th style="width:50px;"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="y in x.poItems"
                                                                :key="y.id"
                                                                class="
                                                                    border-bottom
                                                                "
                                                            >
                                                                <td class="py-2 px-2">
                                                                    <span v-if="!y.editQuantity">{{ y.quantity }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.quantity"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    <div>
                                                                        {{
                                                                            y.itemName
                                                                        }}
                                                                    </div>
                                                                    <small>{{
                                                                        y.description
                                                                    }}</small>
                                                                </td>
                                                                <td class="py-2">
                                                                    <span v-if="!y.editQuantity">{{ y.prNote }}</span>
                                                                    <input
                                                                        v-else
                                                                        type="text"
                                                                        class="form-control"
                                                                        v-model="y.prNote"
                                                                    />
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td class="py-2">
                                                                    {{
                                                                        formatCurrency(
                                                                            y.unitCost *
                                                                                y.quantity
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <a href="javascript:void(0);" v-if="!y.editQuantity" class="text-white font-size-18" @click="updateQuantity(y)" title="Edit Quantity"><i class="bx bx-edit"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-success me-1 font-size-18" @click="saveDetails(y)" title="Save Quantity"><i class="bx bx-check"></i></a>
                                                                    <a href="javascript:void(0);" v-if="y.editQuantity" class="text-white font-size-18" @click="cancelUpdateQty(y)" title="Cancel"><i class="bx bx-x"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="text-right mt-4">
                                                        <button type="button" class="btn btn-purple" @click="printDP(x.id)"><i class="bx bx-printer me-1"></i>Print Deployment</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <div class="row mb-2 mt-4" v-if="postedPO.length > 0">
                        <div class="col-md-12 text-right">
                            <ul
                                class="pagination pagination-rounded mb-0 float-end"
                            >
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPagePosted"
                                    :total-rows="rowsPosted"
                                    :per-page="perPagePosted"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
            <div class="position-absolute" style="top: 0; right: 0;">
                <button type="button" class="btn btn-purple" @click="generatePOStatus"><i class="bx bx-printer"></i> Generate P.O Status</button>
            </div>
        </div>
        <print-options ref="printOpt"></print-options>
    </Layout>
</template>

